import React from 'react';
import { GridContainer, GridRow, GridColumn } from "arv-reactcomponents";
import { MYACCOUNTPAGE } from "npmlinks-constants";
import LoyaltyTierHeader from "./LoyaltyTierHeader";
import LoyaltyTierBody from "./LoyaltyTierBody";

const { LOYALTY } = MYACCOUNTPAGE;

const LoyaltyTiersBlock = props => (
  <section>
    <LoyaltyTierHeader.component />
    <LoyaltyTierBody.component {...props} />
  </section>
)

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: LoyaltyTiersBlock,
  component: LoyaltyTiersBlock,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MyAccountComponent/MyAccountLoyalty/LoyaltyMoreInfoModal/LoyaltyTiersBlock/index.js